export const getCurrencySymbol = (code, currencies = []) => {
    if (!code) {
        return "";
    }

    const configuredSymbol = currencies.find(c => c.code === code)?.symbol;
    if (configuredSymbol) {
        return configuredSymbol;
    }

    try {
        return new Intl.NumberFormat(undefined, {
            style: "currency",
            currency: code,
            currencyDisplay: "narrowSymbol",
        })
            .formatToParts(0)
            .find((part) => part.type === "currency")?.value ?? code;
    } catch {
        return code;
    }
};

export const toCurrencyOptions = (currencies = []) =>
    currencies.map(c => ({ value: c.code, label: `${c.code} — ${c.name}` }));